import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { AnalisesGerenteProjeto } from '../../models/analises-gerente-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { AnalisesGerenteProjetoService } from '../../services/analises-gerente-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-analises-gerente-list',
  templateUrl: './detalhe-projeto-analises-gerente-list.component.html',
  styleUrls: ['./detalhe-projeto-analises-gerente-list.component.scss']
})
export class DetalheProjetoAnalisesGerenteListComponent extends BaseListComponent<AnalisesGerenteProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  anteriores: boolean = false;
  permission: any = {};
  analises: AnalisesGerenteProjeto[];

  constructor(
    private myService: AnalisesGerenteProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initLoadDataTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.analises = res['analises'];
        this.permission = res;
        this.loaded();
      })
    );
  }

  novaDemanda() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(id: number){
    return { pf_analysis_id: id } ;
  }

  mostrarAnteriores() {
    this.anteriores = !this.anteriores;
  }

  novo() {
    return ['/projetos', 'projeto', this.idProjeto, 'analises', 'gerente', 'adicionar'];
  }

  confirmExcluir(item : any) {
    if( !item.last_one ) {
      this.msgError("Apenas a última análise pode ser excluída ou editada.")
      return;
    }

    let id = item?.id
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        if( error.error?.message ) this.msgError(error.error.message)
        this.loaded();
      }
    });
  }

  editar(id: number) {
    return ['/projetos', 'projeto', this.idProjeto, 'analises', 'gerente', id];
  }
}
